import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { environment } from "environments/environment";
import { setTotal } from "../credit.reducer";
import { RootState } from "../../product/product.store";

export const fetchTotalThunk = createAsyncThunk('credits/fetchTotal', async (_, { getState, dispatch }) => {
    const state = (getState() as RootState).credit;
    const shipping = state.shipping.selectShippingMethod ? {
        method: state.shipping.selectShippingMethod?.code,
        zone: state.shipping.shippingZone,
        pickup: state.shipping.shippingPickup,
        city: state.shipping.shippingCity,
        address: state.shipping.shippingAddress
    } : null;

    const result = await axios.post(`${ environment.urls.credits.fetchTotal }`, {
        productId: state.productId,
        credit: state.selectCredit?.id,
        month: state.selectMonth?.id,
        avanse: state.avanse,
        subscription: state.selectSubscription?.id ?? 0,
        shipping
    });

    dispatch(setTotal(result.data));
})